// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"75d9e893","453":"f8c34e36"}[chunkId] + ".chunk.js";
};